import type { PaymentSelection, SchedulePreview, SchedulePreviewParams } from '../../../types/schedule.types';
import { isValidPaymentSelection } from '../../../types/schedule.types';
import { schedulePreviewParamsEqual } from './derive';

/** `?? 0` on both lead sides keeps pre-lead quotes confirmed. The stale notice is params-level by design:
 *  a settled snapshot that differs is re-recorded by the auto-commit in the same tick. */
export function resolveSelectionConfirmation(options: {
    paymentSelection: PaymentSelection | undefined;
    selectedMethodKey: string | null;
    params: SchedulePreviewParams | null;
    data: SchedulePreview | undefined;
    recordedLeadMonths: number | undefined;
}): { isCurrentSelectionConfirmed: boolean; showStaleNotice: boolean } {
    const { paymentSelection, selectedMethodKey, params, data, recordedLeadMonths } = options;
    if (!isValidPaymentSelection(paymentSelection) || paymentSelection.methodKey !== selectedMethodKey) {
        return { isCurrentSelectionConfirmed: false, showStaleNotice: false };
    }
    const isCurrentSelectionConfirmed =
        !!params &&
        schedulePreviewParamsEqual(paymentSelection.params, params) &&
        (paymentSelection.collectionLeadMonths ?? 0) === (recordedLeadMonths ?? 0);

    return {
        isCurrentSelectionConfirmed,
        showStaleNotice: !isCurrentSelectionConfirmed && !!params && !!data,
    };
}
